module.exports = __webpack_public_path__ + "static/media/add complaint.3462a7f3.svg";